import { AccountingGroup } from '@shared/interfaces/accounting-group';
import { Observable } from 'rxjs';

export const ACCOUNTING_GROUP_REPOSITORY = 'AccountingGroupsRepository';

export interface AccountingGroupsRepository {
  url: string;

  getItems(): Observable<any>;

  add(accountingGroup: AccountingGroup): Observable<any>;

  edit(accountingGroup: AccountingGroup): Observable<any>;

  delete(item: any): Observable<any>;
}
